import Cookies from 'js-cookie';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
   useRecoilRefresher_UNSTABLE,
   useRecoilState,
   useRecoilValue,
   useSetRecoilState,
} from 'recoil';
import AdminPaging from '../components/admin-paging/admin-paging';
import AdminSortFilter from '../components/admin-sort-filter/admin-sort-filter';
import AppFooter from '../components/app-footer/app-footer';
import AppHeader from '../components/app-header/app-header';
import CardAffiliate from '../components/card-affiliate/card-affiliate';
import Search, { ISearchProps } from '../components/search/search';
import {
   IAffiliateImpersonation,
   IAffiliateRecent,
   IAffiliateShort,
} from '../lib/types';
import {
   affiliateRecentSelector,
   reloadRecentAffiliates,
} from '../recoil/admin-affiliate-recent';
import { adminImpersonateCookie } from '../recoil/admin-impersonate';
import { adminPagingAtom } from '../recoil/admin-paging';
import {
   adminAffiliatesSearchQueryAtom,
   searchedAffiliatesSelector,
} from '../recoil/admin-search';
import { filteredSortedAffiliatesSelector } from '../recoil/admin-sort-filter';
import './admin.scss';
import { organizationNameAtom } from '../recoil/admin';

export default function AdminPage(): JSX.Element {
   const { organizationName } = useParams<{ organizationName: string }>();
   const setOrganizationName = useSetRecoilState(organizationNameAtom);
   const affiliateRecents: IAffiliateRecent[] = useRecoilValue(affiliateRecentSelector);
   const affiliateRecentRefresh = useRecoilRefresher_UNSTABLE(affiliateRecentSelector);
   const [reloadRecent, setReloadRecent] = useRecoilState(reloadRecentAffiliates);
   const [shouldReload, setShouldReload] = useState(false);
   const cookie: IAffiliateImpersonation | null = useRecoilValue(adminImpersonateCookie);
   const affiliates: IAffiliateShort[] = useRecoilValue(filteredSortedAffiliatesSelector);
   const currentPage: number = useRecoilValue(adminPagingAtom);

   useEffect(() => {
      let reload = false;

      if (organizationName) {
         setOrganizationName(organizationName);
      }

      if (reloadRecent) {
         affiliateRecentRefresh();
         setReloadRecent(false);
      }

      if (cookie) {
         Cookies.remove('x-affdash-actor');
         reload = true;
      }

      if (reload) {
         setShouldReload(true);
      }

      if (shouldReload) {
         window.location.reload();
      }
   }, [organizationName, setOrganizationName, reloadRecent, affiliateRecentRefresh, setReloadRecent, cookie, shouldReload]);

   const searchProps: ISearchProps = {
      placeholderPrimary: 'for an Attorney or Paralegal ',
      placeholderSecondary: 'by name',
      searchQueryAtom: adminAffiliatesSearchQueryAtom,
      searchResultSelector: searchedAffiliatesSelector,
      resultPageLink: 'affiliate-details',
      searchById: false,
      affiliateRecents: affiliateRecents,
      disabled: false,
   };

   return (
      <div className="admin">
         <div className="app-body">
            <AppHeader overrideName={false} />
            <Search {...searchProps} affiliates={affiliates} />
            <AdminSortFilter />
            <div className="content-row-wrapper">
               <div className="admin-content">
                  {affiliates
                     .slice(0 + 25 * currentPage, 25 + 25 * currentPage)
                     .map((a) => (
                        <CardAffiliate key={a.id} affiliate={a} />
                     ))}
                  <AdminPaging />
               </div>
            </div>
         </div>
         <AppFooter />
      </div>
   );
}
